import { EmployerAccounts } from "@/employer/types";
import _ from "lodash";

export default class CompanyHelper {


    bankInformation: EmployerAccounts;

    constructor (bankInfo: EmployerAccounts) {
        this.bankInformation = bankInfo;
    }

    get bankAccountFeeConfirmFieldIsRequired (): string {
        return this.bankInformation.feeAccount.bankAccountNumber &&
            this.bankInformation.feeAccount.bankAccountNumber.length ? "required|confirmed:bank-account" : "required";
    }

    get bankAccountHsaConfirmFieldIsRequired (): string {
        return this.bankInformation.fundingAccount.bankAccountNumber &&
            this.bankInformation.fundingAccount.bankAccountNumber.length ?
            "required|confirmed:bank-account-hsa" : "required";
    }

    get maskedFeesBaNumber () {
        return _.pad("", this.bankInformation.feeAccount.bankAccountNumber.length, "X");
    }

    get maskedFeesRoutingNumber () {
        return _.pad("", this.bankInformation.feeAccount.bankRoutingNumber.length, "X");
    }

    get maskedFundingBaNumber () {
        return _.pad("", this.bankInformation.fundingAccount.bankAccountNumber.length, "X");
    }

    get maskedFundingRoutingNumber () {
        return _.pad("", this.bankInformation.fundingAccount.bankRoutingNumber.length, "X");
    }
}
